import React from 'react';
import Form from '../../components/common/Form';
import {getJwt} from '../../services/authService';
import * as authService from '../../services/authService';
import http from '../../services/httpService';
import toastr from "toastr";

import {Classes, Overlay} from "@blueprintjs/core";

class DeleteContactsModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            overlayIsOpen: false,
            errors: {},
            deleteActive: false
        };
    }

    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }

    componentDidUpdate() {

        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
    }

    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    handleDeleteContacts = async (e) => {
        let deletionOfAllLastPageContacts = (this.props.currentPage === this.props.totalPages) &&
            (this.props.totalContacts - (this.props.pageSize * (this.props.currentPage - 1)) === this.props.checkedContactsIds.length)
        let pageAfterDelete = deletionOfAllLastPageContacts ? (this.props.currentPage - 1) : this.props.currentPage
        try {
            this.setState({deleteActive: true})
            let result = await http.delete('api/user/' + this.props.user + '/project/' + this.props.selected_source +
                '/delete_specific_contacts/page_size/' + this.props.pageSize + '?page=' + pageAfterDelete
                , {
                    headers: {authorization: authService.getJwt()},
                    data: {subscriber_ids: this.props.checkedContactsIds}
                });
            // console.log('delete contacts result: ', result);
            let data = await result.data.contacts.data;
            let totalContacts = await result.data.total_contacts;
            let totalPages = await result.data.total_pages;

            if (data) {
                this.props.deleteContacts(data, totalContacts, pageAfterDelete, totalPages)
            }
            this.setState({deleteActive: false})
        } catch (e) {
            toastr.error("DELETING OF CONTACTS WAS UNSUCCESSFUL.");
            //console.log('Delete Contacts error response: ', e)
            this.setState({deleteActive: false})
        }
    };


    render() {

        return (
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.state.overlayIsOpen}
                autoFocus={true}
                canEscapeKeyClose
                canOutsideClickClose={true}
                enforceFocus={true}
                hasBackdrop={true}
                usePortal={true}
                transitionDuration={100}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field-payment"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2 className=''>Delete contacts</h2>
                        </div>
                        <div className="modal-main">
                            <div className='margin-top-20 margin-bottom-20'>

                            <span>Are you sure you want to delete {this.props.type === 'deleteAllContacts' ? 'all' : 'selected'} contacts?
                            </span>
                            </div>
                            <div className='justify-content-end flex-direction-row margin-bottom-30'>
                                {this.props.type === 'deleteAllContacts' ?
                                    <button
                                        disabled={false}
                                        onClick={() => {
                                            this.props.handleClose()
                                            this.handleClose()
                                        }}
                                        name="cancel_delete_tag"
                                        id="cancel_delete_tag"
                                        type="button"
                                        className="btn-white-border margin-right-10">Cancel
                                    </button>
                                    :
                                    <button
                                        disabled={false}
                                        onClick={() => {
                                            this.props.deleteContacts('Cancel')
                                            this.handleClose()
                                        }}
                                        name="cancel_delete_tag"
                                        id="cancel_delete_tag"
                                        type="button"
                                        className="btn-white-border margin-right-10">Cancel
                                    </button>
                                }
                                {
                                    this.props.type === 'deleteAllContacts' ?

                                        this.state.deleteActive ?
                                            <button disabled={true}
                                                    name="delete_Contacts"
                                                    id="delete_Contacts"
                                                    type="button"
                                                    className="btn-danger ">Delete All Contacts <i
                                                className='fa fa-spin fa-spinner'/>
                                            </button>
                                            :
                                            <button disabled={false}
                                                    name="delete_Contacts"
                                                    id="delete_Contacts"
                                                    type="button"
                                                    onClick={this.handleDeleteContacts}
                                                    className="btn-danger ">Delete All Contacts
                                            </button>


                                        :

                                        this.state.deleteActive ?
                                            <button disabled={true}
                                                    name="delete_Contacts"
                                                    id="delete_Contacts"
                                                    type="button"
                                                    className="btn-danger ">Delete <i className='fa fa-spin fa-spinner'/>
                                            </button>
                                            :
                                            <button disabled={false}
                                                    name="delete_Contacts"
                                                    id="delete_Contacts"
                                                    type="button"
                                                    onClick={this.handleDeleteContacts}
                                                    className="btn-danger">Delete
                                            </button>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </Overlay>
        )
    }
}

export default DeleteContactsModal;